import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
import ExportDoc from "../../../Components/Common/ExportDoc";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import FormData from "form-data";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getVillage, resetVillageState } from "../../../store/village/action";
import { getAgency, resetAgencyState } from "../../../store/agency/action";
import { deleteFile } from "../../../store/file/action";
import { getBank } from "../../../store/bank/action";
import { resetUserState, getUser } from "../../../store/users/action";
import { resetAgentState, getAgent as onGetAgents, addNewAgent as onAddNewAgent, updateAgent as onUpdateAgent, deleteAgent as onDeleteAgent, getAgentLoading } from "../../../store/agent/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";

const Agent = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, agents, isAgentCreated, isAgentSuccess, loading, error, agencys, agencysLoading, villages, villageLoading, companies, companyLoading, clients, clientLoading, banks, bankLoading, users, usersLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    agents: state.Agent.agents,
    isAgentCreated: state.Agent.isAgentCreated,
    isAgentSuccess: state.Agent.isAgentSuccess,
    loading: state.Agent.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    villages: state.Village.villages,
    villageLoading: state.Village.loading,
    error: state.Agent.error,
    agencys: state.Agency.agencys,
    agencysLoading: state.Agency.loading,
    users: state.Users.users,
    usersLoading: state.Users.loading,
  }));

  const [agentList, setAgentList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [agentDoc, setAgentDoc] = useState([]);
  const [userList, setUserList] = useState([]);
  const [agent, setAgent] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [agentContactItem, setAgentContactItem] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [bankList, setBankList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  useEffect(() => {
      let dataDoc = [
        {
          id: "name",
          label: "Nama",
          isSelected: true,
          data: [],
        },
        {
          id: "code",
          label: "Code",
          isSelected: true,
          data: [],
        },
        {
          id: "agency_agent",
          label: "Mitra",
          isSelected: true,
          data: [],
        },
        {
          id: "phone",
          label: "Telepon",
          isSelected: true,
          data: [],
        },
        {
          id: "email",
          label: "Email",
          isSelected: true,
          data: [],
        },
        {
          id: "description",
          label: "Keterangan",
          isSelected: true,
          data: [],
        },
        {
          id: "agent_client",
          label: "Grup Usaha",
          isSelected: true,
          data: [],
        },
        {
          id: "agent_company",
          label: "Perusahaan",
          isSelected: true,
          data: [],
        },
      ];
  
      if (agentList.length > 0) {
        agentList.forEach((data) => {
          if (data.isChecked) {
            Object.entries(data).forEach(([key, value]) => {
              const doc = dataDoc.find((d) => d.id === key);
              if (doc) {
                if (doc.id === "agent_client" || doc.id === "agent_client" || doc.id === "agency_agent") {
                  doc.data.push(value?.name ?? "");
                } else {
                  doc.data.push(value ?? "-");
                }
              }
            });
          }
        });
      }
  
      setAgentDoc(dataDoc);
    }, [agentList]);

  const onClickDelete = (agent) => {
    setAgent(agent);
    setDeleteModal(true);
  };

  const onClickApprove = (agent) => {
    setAgent(agent);
    setApproveModal(true);
  };

  const handleDeleteAgent = () => {
    if (agent) {
      dispatch(onDeleteAgent(agent));
      setDeleteModal(false);
    }
  };

  const handleApproveAgent = () => {
    if (agent) {
      agent.setApprove = true;
      dispatch(onUpdateAgent(agent));
      setApproveModal(false);
    }
  };

  const handleUser = (e, t) => {
    validation.setFieldValue("user", "");
    const param = t === "client" ? { clientId: e, userType: "user" } : { companyId: e, userType: "user" };
    dispatch(getUser(param));
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    dispatch(resetAgentState());
    dispatch(onGetAgents({ simple: true }));
    handleGetGroup(userData?.companyId);
    handleUser(userData?.companyId);
  }, []);

  useEffect(() => {
    if (!isEmpty(agents)) {
      let filteredAgents = agents;
      if (activeTypeTab !== "all") {
        filteredAgents = agents.filter((agent) => agent.agent_status.name === activeTypeTab);
      }
      setAgentList(filteredAgents.map((el) => ({ ...el, isChecked: false })));
      setInfo(agents[agents.length - 1]);
      setIsEdit(false);
    }
  }, [agents]);

  useEffect(() => {
    if (!isEmpty(users)) {
      var data = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const phone = item.phone;
        const email = item.email;
        const id = item.id;
        var obj = { label: name, value: id, phone: phone, email: email };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUserList(data);
    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agencys.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (agencys.length > 0) {
      setAgencyList(data);
    }
  }, [agencys]);

  const promiseOptions = (e) => {
    if (!villageLoading) {
      dispatch(resetVillageState());
      setVillageList([]);
      if (e.length > 3) {
        dispatch(getVillage({ title: e }));
      }
      return new Promise((resolve, reject) => {
        while (villageLoading);
        resolve(villageList);
      });
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  useEffect(() => {
    if (!isEmpty(villages)) {
      var villageData = [];
      var opt = [];
      villages.forEach((item, key) => {
        const village_name = item.village_name;
        const id = item.id;
        const city_name = item.vc.city_name;
        const district_name = item.vd.district_name;
        const province_name = item.vp.province_name;
        var obj = { label: village_name + ", " + district_name + ", " + city_name + " - " + province_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      villageData.push(option);
      setVillageList(villageData);
    }
  }, [villages]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAgents = agents;
      if (type !== "all") {
        filteredAgents = agents.filter((agent) => agent.agent_status.name === type);
      }
      setAgentList(filteredAgents);
    }
  };

  useEffect(() => {
    if (banks && !banks.length) {
      dispatch(getBank());
    }
  }, [dispatch, banks]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAgent(null);
      setAgentContactItem([]);
      setPlaceDefaultVal("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = useCallback(
    (id) => {
      dispatch(resetCompanyState());
      dispatch(getCompany({ clientId: id }));
    },
    [dispatch],
  );

  const handleGetGroup = useCallback(
    (companyId) => {
      dispatch(resetCompanyState());
      dispatch(getAgency({ companyId: companyId }));
    },
    [dispatch],
  );

  const handleAgentClick = useCallback(
    (arg) => {
      const agent = arg;
      let venaddress = [];
      let venbank = [];
      let venagent = [];
      agent.agent_address.forEach((address) => {
        if (address.isPrimary) venaddress = address;
      });
      const addressName = venaddress ? venaddress.address_name : "";
      const addressLabel = venaddress ? venaddress.description : "";
      const addressValue = venaddress ? venaddress.villageId : "";

      let address_agent = {};
      for (const address of agent.agent_address) {
        if (address.isPrimary) {
          address_agent = address;
        }
      }

      agent.agent_bank.forEach((bank) => {
        if (bank.isPrimary) venbank = bank;
      });

      if (agent.agent_contact) {
        agent.agent_contact.forEach((element) => {
          venagent.push({
            id: element.id,
            name: element.name,
            email: element.email,
            phone: element.phone,
            position: element.position,
          });
        });
        setAgentContactItem(venagent);
      }

      setPlaceDefaultVal({
        label: `${address_agent.village} ${address_agent.district} ${address_agent.city} ${address_agent.province} ${address_agent.country}`,
        value: `${address_agent.village} ${address_agent.district} ${address_agent.city} ${address_agent.province} ${address_agent.country}`,
      });

      setAgent({
        id: agent.id,
        idBank: venbank.id ?? 0,
        address: {
          label: `${address_agent.village} ${address_agent.district} ${address_agent.city} ${address_agent.province} ${address_agent.country}`,
          value: `${address_agent.village} ${address_agent.district} ${address_agent.city} ${address_agent.province} ${address_agent.country}`,
        },
        street: address_agent.description ?? "",
        zip: address_agent.code ?? "",
        village: address_agent.village ?? "",
        district: address_agent.district ?? "",
        city: address_agent.city ?? "",
        province: address_agent.province ?? "",
        country: address_agent.country ?? "",
        name: agent.name,
        email: agent.email,
        password: agent.agent_user ? agent.agent_user.pass : "",
        phone: agent.phone,
        fax: agent.fax,
        image: agent.image,
        tax_number: agent.tax_number,
        website: agent.website,
        user:
          agent.agent_user === null
            ? ""
            : {
              label: agent.agent_user ? agent.agent_user.name : "",
              value: agent.agent_user ? agent.agent_user.id : "",
            },
        description: agent.description,
        number: venbank.number,
        bank: venbank.bank_data_bank && {
          label: venbank.bank_data_bank.name,
          value: venbank.id,
        },
        agent_status: {
          label: agent.agent_status.name,
          value: agent.agent_status.id,
        },
        agency: agent.agency_agent && {
          label: agent.agency_agent ? agent.agency_agent.name : "",
          value: agent.agency_agent ? agent.agency_agent.id : "",
        },
        agent_contact: venagent,
        client: agent.agent_client && {
          label: agent.agent_client ? agent.agent_client.name : "",
          value: agent.agent_client ? agent.agent_client.id : "",
        },
        company: agent.agent_company && {
          label: agent.agent_company ? agent.agent_company.name : "",
          value: agent.agent_company ? agent.agent_company.id : "",
        },
        instagram: agent?.social_media?.instagram,
        facebook: agent?.social_media?.facebook,
        tiktok: agent?.social_media?.tiktok,
        youtube: agent?.social_media?.youtube,
        twitter: agent?.social_media?.twitter,
      });

      handleGetCompany(agent.agent_client.id);
      handleGetGroup(agent.agent_company.id);
      setIsEdit(true);
      toggle();
    },
    [toggle, userType, handleGetCompany, handleGetGroup],
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = agentList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAgentList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = agentList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAgentList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAgent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAgentClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAgent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {cellProps.row.original.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : userRole && userRole.split(",").indexOf("approveAgent") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : "btn-label btn btn-sm btn-soft-success fs-12 ms-2 d-none"}
                  onClick={() => {
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        id: "#Name",
        Header: "Nama",
        filterable: true,
        accessor: "name",
        Cell: (agent) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {agent.row.original.image ? (
                  <img src={agent.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${agent.row.original.image}`} alt="" className="avatar-xs rounded-circle me-1" />
                ) : (
                  <div className="flex-shrink-0 avatar-xs me-1">
                    <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{agent.row.original.name.charAt(0)}</div>
                  </div>
                )}
              </div>
              <div className="flex-grow-1 ms-2 name">{agent.row.original.name}</div>
            </div>
          </>
        ),
      },
      {
        id: "#Mitra",
        Header: "Mitra",
        accessor: "agency_agent.name",
        filterable: true,
      },
      {
        id: "#Phone",
        Header: "Telepon",
        accessor: "phone",
        filterable: true,
      },
      {
        id: "#Email",
        Header: "Email",
        accessor: "email",
        filterable: true,
      },
      {
        id: "#Status",
        Header: "Status",
        accessor: "agent_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [agentList, handleAgentClick, logo, userType, userRole, isCheckAll],
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = agentList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAgentList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => agentList, [agentList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  // const onChange = useAsyncDebounce((value) => {
  //   setGlobalFilter(value || undefined);
  // }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      simple: true
    };
    dispatch(onGetAgents(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAgentList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    dispatch(resetAgentState());
    dispatch(onGetAgents({ simple: true }));
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      company: (agent && agent.company) || companySelected,
      client: (agent && agent.client) || clientSelected,
      agency: (agent && agent.agency) ?? "",
      name: (agent && agent.name) ?? "",
      user: (agent && agent.user) ?? "",
      email: (agent && agent.email) ?? "",
      password: (agent && agent.password) ?? "",
      phone: (agent && agent.phone) ?? "",
      birthat: (agent && agent.birthat) ?? "",
      fax: (agent && agent.fax) ?? "",
      tax_number: (agent && agent.tax_number) ?? "",
      number: (agent && agent.number) ?? "",
      website: (agent && agent.website) ?? "",
      description: (agent && agent.description) ?? "",
      address: (agent && agent.address) ?? "",
      agent_status: agent && agent.agent_status,
      village: agent && agent.village,
      bank: (agent && agent.bank) ?? "",
      idBank: (agent && agent.idBank) || 0,
      zip: (agent && agent.zip) ?? "",
      street: (agent && agent.street) ?? "",
      image: (agent && agent.image) ?? "",
      instagram: (agent && agent.instagram) ?? "",
      facebook: (agent && agent.facebook) ?? "",
      tiktok: (agent && agent.tiktok) ?? "",
      youtube: (agent && agent.youtube) ?? "",
      twitter: (agent && agent.twitter) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Agent Name").nullable(true),
      phone: Yup.string().required("Please Enter Phone Number").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getAgentLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: agent.id,
          agencyId: values.agency.value,
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          userId: values.user.value,
          bankId: values.bank.value,
          number: values.number,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : agent.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : agent.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : agent.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : agent.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : agent.country,
          street: values.street,
          agent_contact: JSON.stringify(agentContactItem),
          image: values.image,
          social_media: {
            instagram: values.instagram,
            facebook: values.facebook,
            tiktok: values.tiktok,
            youtube: values.youtube,
            twitter: values.twitter,
          },
        };
        dispatch(onUpdateAgent(editDataSubmit));
      } else {
        let addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          agencyId: values.agency.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          userId: values.user.value,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : "",
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : "",
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : "",
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : "",
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : "",
          street: values.street,
          agent_contact: JSON.stringify(agentContactItem),
          image: values.image,
          social_media: {
            instagram: values.instagram,
            facebook: values.facebook,
            tiktok: values.tiktok,
            youtube: values.youtube,
            twitter: values.twitter,
          },
        };
        dispatch(onAddNewAgent(addDataSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  function handleAgentContactAdd() {
    let fc = [];
    if (agentContactItem && agentContactItem.length) {
      agentContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setAgentContactItem(fc);
  }

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAgent(element.value));
    });
    checkall.checked = false;
  };

  document.title = "Salesman | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={agentList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAgent} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={agent && agent.name ? agent.name : ""} show={approveModal} onApproveClick={handleApproveAgent} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Sales dan Konsumen" pageTitle="Salesman" loading={loading}>
          {" "}
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAgent") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-group-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <ExportDoc data={agentDoc} />

            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger ms-1 add-btn" : userRole && userRole.split(",").indexOf("deleteAgent") !== -1 ? "btn btn-soft-danger ms-1 add-btn" : "btn btn-soft-danger ms-1 add-btn d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i>SEMUA SALESMAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Salesman" : "Tambah Salesman"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                setAgencyList([]);
                                validation.setFieldValue("agency", "");
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                setAgencyList([]);
                                validation.setFieldValue("agency", "");
                                validation.setFieldValue("company", e);
                                handleGetGroup(e.value);
                                handleUser(e.value);
                              }}
                              options={companyList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="agency-field" className="form-label">
                              Grup Salesman (Opsional)&nbsp;
                              {agencysLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="agency"
                              value={validation.values.agency}
                              placeholder="Pilih Grup Salesman"
                              isDisabled={agencyList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("agency", e);
                              }}
                              options={agencyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="agentname-field" className="form-label">
                              Nama Salesman
                            </Label>
                            <Input name="name" id="agentname-field" className="form-control" placeholder="Isi Nama Agen" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="password-field" className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Isi Password" type="password" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password ?? ""} invalid={validation.touched.password && validation.errors.password ? true : false} />
                            {validation.touched.password && validation.errors.password ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.password}
                              </small>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              Telepon{" "}
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                            {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email{" "}
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                            {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street} invalid={validation.touched.street && validation.errors.street ? true : false} />
                            {validation.touched.street && validation.errors.street ? <FormFeedback type="invalid">{validation.errors.street}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              {props.t("Kode Pos")}{" "}
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} invalid={validation.touched.zip && validation.errors.zip ? true : false} />
                            {validation.touched.zip && validation.errors.zip ? <FormFeedback type="invalid">{validation.errors.zip}</FormFeedback> : null}
                          </div>
                          <div className=" mb-3">
                            <Label htmlFor="bank-field" className="form-label">
                              Bank{" "}
                            </Label>
                            <Select
                              name="bank"
                              value={validation.values.bank}
                              placeholder="Pilih Bank"
                              onChange={(e) => {
                                validation.setFieldValue("bank", e);
                              }}
                              options={bankList}
                            ></Select>
                            {validation.touched.bank && validation.errors.bank ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.bank}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="number-field" className="form-label">
                              No. Rekening Bank{" "}
                            </Label>
                            <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.number ?? ""} invalid={validation.touched.number && validation.errors.number ? true : false} />
                            {validation.touched.number && validation.errors.number ? <FormFeedback type="invalid">{validation.errors.number}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              No. Pajak{" "}
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tax_number ?? ""} invalid={validation.touched.tax_number && validation.errors.tax_number ? true : false} />
                            {validation.touched.tax_number && validation.errors.tax_number ? <FormFeedback type="invalid">{validation.errors.tax_number}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="instagram-field" className="form-label">
                                  Instagram
                                </Label>
                                <Input name="instagram" id="instagram-field" className="form-control" placeholder="Isi Instagram" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.instagram ?? ""} invalid={validation.touched.instagram && validation.errors.instagram ? true : false} />
                                {validation.touched.instagram && validation.errors.instagram ? <FormFeedback type="invalid">{validation.errors.instagram}</FormFeedback> : null}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="facebook-field" className="form-label">
                                  Facebook
                                </Label>
                                <Input name="facebook" id="facebook-field" className="form-control" placeholder="Isi Facebook" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.facebook ?? ""} invalid={validation.touched.facebook && validation.errors.facebook ? true : false} />
                                {validation.touched.facebook && validation.errors.facebook ? <FormFeedback type="invalid">{validation.errors.facebook}</FormFeedback> : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="instagram-field" className="form-label">
                                  Tiktok
                                </Label>
                                <Input name="tiktok" id="tiktok-field" className="form-control" placeholder="Isi Tiktok" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tiktok ?? ""} invalid={validation.touched.tiktok && validation.errors.tiktok ? true : false} />
                                {validation.touched.tiktok && validation.errors.tiktok ? <FormFeedback type="invalid">{validation.errors.tiktok}</FormFeedback> : null}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="facebook-field" className="form-label">
                                  Youtube
                                </Label>
                                <Input name="youtube" id="youtube-field" className="form-control" placeholder="Isi Youtube" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.youtube ?? ""} invalid={validation.touched.youtube && validation.errors.youtube ? true : false} />
                                {validation.touched.youtube && validation.errors.youtube ? <FormFeedback type="invalid">{validation.errors.youtube}</FormFeedback> : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="instagram-field" className="form-label">
                                  Twiter
                                </Label>
                                <Input name="twitter" id="twitter-field" className="form-control" placeholder="Isi Twitter" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.twitter ?? ""} invalid={validation.touched.twitter && validation.errors.twitter ? true : false} />
                                {validation.touched.twitter && validation.errors.twitter ? <FormFeedback type="invalid">{validation.errors.twitter}</FormFeedback> : null}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="website-field" className="form-label">
                                  Website{" "}
                                </Label>
                                <Input name="website" id="website-field" className="form-control" placeholder="Isi Website" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.website ?? ""} invalid={validation.touched.website && validation.errors.website ? true : false} />
                                {validation.touched.website && validation.errors.website ? <FormFeedback type="invalid">{validation.errors.website}</FormFeedback> : null}
                              </div>
                            </Col>
                          </Row>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan (optional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan (Opsional)" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            {validation.touched.description && validation.errors.description ? <FormFeedback type="invalid">{validation.errors.description}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 position-relative">
                            <Label htmlFor="agent_contact" className="form-label">
                              Kontak Salesman
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleAgentContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                            </button>
                          </div>
                          {agentContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Nama{" "}
                                      </Label>
                                      <Input
                                        name={`agentContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Nama Kontak"
                                        type="text"
                                        value={agentContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agentContactItem.${i}.name`, e.target.value);
                                          agentContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Telepon
                                      </Label>
                                      <Input
                                        name={`agentContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Isi No. Telepon"
                                        type="text"
                                        value={agentContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agentContactItem.${i}.phone`, e.target.value);
                                          agentContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email{" "}
                                      </Label>
                                      <Input
                                        name={`agentContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Isi Email"
                                        type="text"
                                        value={agentContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agentContactItem.${i}.email`, e.target.value);
                                          agentContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Posisi{" "}
                                      </Label>
                                      <Input
                                        name={`agentContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Isi Posisi"
                                        type="text"
                                        value={agentContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agentContactItem.${i}.position`, e.target.value);
                                          agentContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{
                                    width: "70px",
                                  }}
                                  onClick={() => {
                                    setAgentContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                    // let data = cellProps.row.original;
                                    // onClickDelete(data);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative">
                            <Label htmlFor="agent_contact" className="form-label">
                              Gambar
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("image", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Agent"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                        GENERAL INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    KONTAK SALESMAN
                                  </td>
                                </tr>
                                {info.agent_contact ? (
                                  info.agent_contact.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Name</td>
                                          <td className="p2">{row.name ? row.name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Email</td>
                                          <td className="p2">{row.email ? row.email : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Phone</td>
                                          <td className="p2">{row.phone ? row.phone : "-"} </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    INFORMASI ALAMAT
                                  </td>
                                </tr>
                                {info.agent_address &&
                                  info.agent_address.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Address</td>
                                          <td className="p2">
                                            {row.village ? row.village : "-"}, {row.city ? row.city : "-"}, {row.district ? row.district : "-"}, {row.province ? row.province : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Street</td>
                                          <td className="p2">
                                            {row.description ? row.description : "-"} - {row.code ? row.code : "-"}{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2" colSpan={"2"}></td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    INFORMASI BANK
                                  </td>
                                </tr>
                                {info.agent_bank &&
                                  info.agent_bank.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2" colSpan="2">
                                            {row.bank_data_bank ? row.bank_data_bank.name : "-"}{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Primary</td>
                                          <td className="p2">{row.isPrimary ? "Yes" : "No"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">No. Rekening Bank</td>
                                          <td className="p2">{row.number ? row.number : "-"} </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2">NO. PAJAK</td>
                                  <td className="p2">{info.tax_number ? info.tax_number : "-"} </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                        OTHER CONTACT INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <div className="col-lg-12">
                          {(info.agent_contact || []).map((row) => {
                            return (
                              <table className="table border table-responsive table-striped fs-13 mb-3" key={row.id}>
                                <tbody>
                                  <tr>
                                    <td className="p2">Name</td>
                                    <td className="p2">{row.name ? row.name : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Position</td>
                                    <td className="p2">{row.position ? row.position : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Email</td>
                                    <td className="p2">{row.email ? row.email : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Phone</td>
                                    <td className="p2">{row.phone ? row.phone : "-"} </td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })}
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                        OTHER INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2">Dibuat Oleh</td>
                              <td className="p2">{info.agent_createdby && info.agent_createdby.name ? info.agent_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Diedit Oleh</td>
                              <td className="p2">{info.agent_updatedby && info.agent_updatedby.name ? info.agent_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Approved By</td>
                              <td className="p2">{info.agent_approvedby && info.agent_approvedby.name ? info.agent_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Agent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Agent));
